module.exports = __webpack_public_path__ + "img/icon-3-2.9a4ec18e.png";